export default "<a id=\"ccc-link\" href=\"#N\">\n    <slot></slot>\n</a>\n";